const REPORT_TOKEN_REGEX = /[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}\s*\(([^)]+)\)/gi;

function extractNameFromReportToken(token: string): string {
  const match = /[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}\s*\(([^)]+)\)/i.exec(token);
  return match?.[1]?.trim() ?? '';
}

function getNamesFromParameterItem(item: unknown): string {
  if (typeof item === 'string') {
    return extractNameFromReportToken(item) || item.trim();
  }
  if (!item || typeof item !== 'object') {
    return '';
  }
  const report = item as { name?: string; Name?: string; readableId?: string };
  return (report.name || report.Name || report.readableId || '').trim();
}

function getNamesFromParameters(parameters: unknown): string[] {
  if (!parameters) {
    return [];
  }
  if (Array.isArray(parameters)) {
    return parameters.map(getNamesFromParameterItem).filter(Boolean);
  }
  if (typeof parameters !== 'object') {
    return [];
  }
  const params = parameters as Record<string, unknown>;
  const candidates =
    params.nonConformances ?? params.NonConformances ?? params.reports ?? params.Reports;
  if (!Array.isArray(candidates)) {
    return [];
  }
  return candidates.map(getNamesFromParameterItem).filter(Boolean);
}

function getNamesFromMessage(message?: string): string[] {
  if (!message) {
    return [];
  }
  const names: string[] = [];
  const regex = new RegExp(REPORT_TOKEN_REGEX.source, 'gi');
  let match = regex.exec(message);
  while (match) {
    names.push(match[1].trim());
    match = regex.exec(message);
  }
  return names;
}

export function getResponsibleNonConformanceReportNames(
  message?: string,
  parameters?: unknown
): string[] {
  const fromParams = getNamesFromParameters(parameters);
  if (fromParams.length) {
    return fromParams;
  }
  return getNamesFromMessage(message);
}
